import { useState } from "react";
import { InputField } from "../../../components/forms/InputField";
import { QuestionWithRelations } from "../../../../../api/src/types";
import { validateQuestionnaireNumber } from "../utils/questionnaire";
import { useGetCurrentUserQuery } from "../../../api/users";
import { useUpsertAnswerMutation } from "../../../api/answers";
import { ErrorWrapper, InputWrapper } from "./SharedFormStyles";
import { QUESTIONNAIRE_INPUT_PLACEHOLDER_TEXT } from "../../../components/theme";

interface NumberFieldInputProps {
  question: QuestionWithRelations;
  documentId: string;
}

const NumberFieldInput: React.FC<NumberFieldInputProps> = ({
  question,
  documentId,
}) => {
  const [numberInput, setNumberInput] = useState<number | null>(
    question.answers[0]?.valueTyped
      ? Number(question.answers[0].valueTyped)
      : null,
  );
  const [numberError, setNumberError] = useState<string | null>(null);

  const { data: user } = useGetCurrentUserQuery();
  const [
    upsertAnswer,
    {
      /*isLoading: isCreating,*/
      isError: isUpsertError,
      /*isSuccess: isCreateSuccess,*/
      /*isSuccess: isUpdateSuccess,*/
      reset: resetUpdateAnswer,
    },
  ] = useUpsertAnswerMutation();

  const hasAnswer = question.answers.length > 0;

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    resetUpdateAnswer();

    const value = e.target.value;
    // Only set numeric value if it's not empty and is a valid number
    setNumberInput(value && !isNaN(Number(value)) ? Number(value) : null);

    const error = validateQuestionnaireNumber(value, question);
    setNumberError(error);
    if (!user) return;

    const payload = {
      questionId: question.id,
      userId: user.id,
      documentId,
      rootQuestionId: question.rootQuestionId ?? question.id,
      sectionId: question.parentQuestionnaireSectionId,
      valueTyped: value,
      serializeDebounceMs: 900,
    };

    if (error) {
      if (hasAnswer) {
        void upsertAnswer({ ...payload, valueTyped: null });
      }
      return;
    }

    // Avoid creating empty answers
    if (!hasAnswer && value.trim().length === 0) return;

    void upsertAnswer(payload);
  };

  //const isLoading = isCreating || isUpdating;
  const hasError = isUpsertError;
  /*
  const isSuccess =
    (isCreateSuccess || isUpdateSuccess) &&
    !hasError &&
    !isLoading &&
    !numberError &&
    (numberInput != null || !question.isRequired);
  */
  return (
    <>
      <InputWrapper>
        <InputField
          type="number"
          placeholder={QUESTIONNAIRE_INPUT_PLACEHOLDER_TEXT}
          value={numberInput ? String(numberInput) : ""}
          onChange={(e) => {
            handleNumberChange(e);
          }}
          required={question.isRequired}
          errorMessage={numberError}
        />
        {/* Commenting out the loader and success icon for now as per the request of the design team */}
        {/*
        {isLoading && (
          <IconContainer>
            <Loader spinnerOnly={true} size={isMobile ? 16 : 34} />
          </IconContainer>
        )}
        {isSuccess && (
          <IconContainer>
            <GreenTick size={isMobile ? IconSize.S : IconSize.XL} />
          </IconContainer>
        )}
        */}
      </InputWrapper>

      {hasError && (
        <ErrorWrapper>
          Error saving answer, please refresh the page and try again
        </ErrorWrapper>
      )}
    </>
  );
};

export default NumberFieldInput;
